import { computed, DOCUMENT, effect, inject, Injectable, signal } from '@angular/core';
import { Language, TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ChangeLangService {
  
private document = inject(DOCUMENT);
private translate = inject(TranslateService);
currentLang = signal((localStorage.getItem('lang') as Language) || 'en');
currentDirection = computed(() => (this.currentLang() === 'ar' ? 'rtl' : 'ltr'));
position = computed(() => (this.currentLang() === 'ar' ? 'right' : 'left'));
constructor() {
// Apply direction changes to document
effect(() => {
const dir = this.currentDirection();
this.document.documentElement.setAttribute('dir', dir);
this.document.body.setAttribute('dir', dir);
});
}
initLang(): void {
const lang = this.currentLang();
this.applyLang(lang);
}
changeLang(lang: Language): void {
localStorage.setItem('lang', lang);
this.currentLang.set(lang);
this.applyLang(lang);
}
private applyLang(lang: Language): void {
this.document.documentElement.lang = lang;
this.translate.use(lang);
}
}
